import React from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import PropertyList from "../../../components/Lists/PropertyList";
import { pickSeason } from "../../../components/Modals/PickSeason";

const PickAProperty = (props) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center">
      <h2 className="text-2xl font-bold mt-10">Select A Property</h2>
      <p className="text-gray-600">
        Pick a property to view and edit it's site map.
      </p>
      <p className="text-gray-600">
        (or{" "}
        <Link to="/admin/property/create" className="underline">
          create a new one
        </Link>
        )
      </p>
      <PropertyList
        filterContainerClass="w-full flex justify-center"
        currentUser={props.currentUser}
        onJobClick={async (jobId) => {
          const season = await pickSeason();
          navigate(`/admin/property/${jobId}/site-map/${season}/edit`);
        }}
        showFiltersDefault={false}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(PickAProperty);
export { PickAProperty };
